import Profile from "../components/Profile";

export default function ProfilePage() {
  return <Profile />;
}
